import { NotificationAction } from '../notificationContext/NotificationActionProvider'
import React, { useContext } from 'react'

export const CancelScheduleNotification = ({
  onClick,
  notification,
  ...rest
}) => {
  const { cancelScheduleNotification } = useContext(NotificationAction)
  const handlerCancelNotification = () => {
    cancelScheduleNotification(notification)
    onClick()
  }
  return <div onClick={handlerCancelNotification} {...rest} />
}
